// extracted by mini-css-extract-plugin
export var snsList = "SnsList-module--snsList--MC0Fy";
export var snsListElement = "SnsList-module--snsListElement--zkr3L";
export var snsListElementAnchor = "SnsList-module--snsListElementAnchor--zQUD1";